// Shared presets for the escort profile & booking forms (HUNQZ-style).
// Used by both Landing Editor and the public booking form.

export const FETISH_PRESETS = [
  "Anal", "Body Hair", "Feet", "Kissing", "Latex", "Cum", "Nipples", "Piercing",
  "Role Play", "Spanking", "S & M", "Socks", "Tickling", "Wrestling", "Armpits",
  "Bears", "Fisting", "Foreskin", "Jocks", "Leather", "Muscle", "PNP", "Rimming",
  "Shaving", "Smoking", "Tattoos", "Verbal", "WS", "Oral", "Daddy", "Twinks",
  "Groups", "Bondage", "Toys",
];

export const SERVICE_PRESETS = [
  "Escort / Companion",
  "Erotic Massage",
  "Domination",
  "Submissive",
  "Virtual / Cam",
  "Live Show / Event",
  "Photo Shoot",
  "Custom Video",
  "Dinner Date",
  "Travel Companion",
  "Couples",
  "Group Sessions",
  "Roleplay",
  "Sensual / GFE",
];

// Each field has: key, label, options[] (empty array = free text input)
export const PROFILE_FIELDS = [
  { key: "age",           label: "Age",           options: [] },
  { key: "ethnicity",     label: "Ethnicity",     options: ["Greek", "Mediterranean", "Caucasian", "Latino", "Middle Eastern", "Asian", "Black", "Mixed", "Other"] },
  { key: "height",        label: "Height",        options: [] }, // free text, e.g. "1.80 m / 5'11\""
  { key: "weight",        label: "Weight",        options: [] }, // free text, e.g. "78 kg / 172 lbs"
  { key: "cock_size",     label: "Cock Size",     options: [] },
  { key: "foreskin",      label: "Foreskin",      options: ["Cut", "Uncut"] },
  { key: "style",         label: "Your Style",    options: ["Masculine", "Athletic", "Boyish", "Hairy", "Smooth", "Bearded", "Clean shaven", "Alternative"] },
  { key: "position",      label: "Position",      options: ["Top", "Versatile Top", "Versatile", "Versatile Bottom", "Bottom"] },
  { key: "body_type",     label: "Body Type",     options: ["Slim", "Athletic", "Muscular", "Bear", "Stocky", "Average", "Twink", "Otter", "Cub"] },
  { key: "body_hair",     label: "Body Hair",     options: ["Smooth", "Light", "Average", "Hairy", "Very Hairy"] },
  { key: "orientation",   label: "Orientation",   options: ["Gay", "Bi", "Bi-curious", "Pansexual", "Straight"] },
  { key: "zodiac",        label: "Zodiac",        options: ["Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"] },
  { key: "eye_color",     label: "Eye Color",     options: ["Brown", "Black", "Blue", "Green", "Hazel", "Grey"] },
  { key: "hair_color",    label: "Hair Color",    options: ["Black", "Brown", "Blonde", "Red", "Grey", "Bald", "Other"] },
  { key: "piercings",     label: "Piercings",     options: ["None", "Few", "Many"] },
  { key: "smoking",       label: "Smoking",       options: ["Non-smoker", "Occasional", "Smoker", "420 friendly"] },
  { key: "tattoos",       label: "Tattoos",       options: ["None", "Few", "Many"] },
  { key: "safe_bb",       label: "Safe / BB",     options: ["Safe only", "BB OK", "Both / depends"] },
  { key: "health_status", label: "Health Status", options: ["Healthy", "Tested regularly", "Disclosed on request"] },
  { key: "hiv_status",    label: "HIV Status",    options: ["Negative", "Negative on PrEP", "Undetectable", "Disclosed on request"] },
];
